import _axios from '@/plugins/axios';
import { BillingsError } from '../../../lib/Errors';

export default {
	async getLogs (headers) {
		const response = await _axios.get('systemLog/getSystemLogs', { headers: headers });
		if (response.data.resFlag) {
			return response.data;
		}
		throw new BillingsError('Error getting time tracking info');
	},
	async getLogById (id) {
		const response = await _axios.get('systemLog/getSystemLogById', {
			headers: { systemLogId: id }, // Ensure the ID is set correctly in headers
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new BillingsError('Error getting time tracking info');
	},
	async getLogWithin2Seconds (id) {
		const response = await _axios.get('systemLog/getLogWithin2Secounds', {
			headers: { systemLogId: id },
		});
		if (response.data.resFlag) {
			return response.data;
		}
		throw new BillingsError('Error getting time tracking info');
	},
};
